import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Company/MembershipRegulations/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>

      <div className={cn('container')}>

        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Membership Regulations', href: '' as Route }]} />

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            Membership Regulations
          </h1>
          <p className={cn('header__heading-description')}>
            To join the Digital Freight Alliance, you need to fulfill several requirements:
          </p>
        </div>

      </div>

    </section>
  );
};

export default SectionHeader;